import Backbone from "backbone";
import BaseView from "scripts/views/baseView";
import ContentDetailsArticlePageDetailsSubPageView from "scripts/views/contentDetailsArticlePageDetailsSubPageView";
import ContentDetailsArticlePageView from "scripts/views/contentDetailsArticlePageView";
import ContentDetailsAudioPageDetailsSubPageView from "scripts/views/contentDetailsAudioPageDetailsSubPageView";
import ContentDetailsAudioPageView from "scripts/views/contentDetailsAudioPageView";
import ContentDetailsBookPageDetailsSubPageView from "scripts/views/contentDetailsBookPageDetailsSubPageView";
import ContentDetailsBookPageView from "scripts/views/contentDetailsBookPageView";
import ContentDetailsChapterPageDetailsSubPageView from "scripts/views/contentDetailsChapterPageDetailsSubPageView";
import ContentDetailsChapterPageView from "scripts/views/contentDetailsChapterPageView";
import ContentDetailsDocumentPageDetailsSubPageView from "scripts/views/contentDetailsDocumentPageDetailsSubPageView";
import ContentDetailsDocumentPageView from "scripts/views/contentDetailsDocumentPageView";
import ContentDetailsImagePageDetailsSubPageView from "scripts/views/contentDetailsImagePageDetailsSubPageView";
import ContentDetailsImagePageView from "scripts/views/contentDetailsImagePageView";
import ContentDetailsPageAlsoFoundInSubPageView from "scripts/views/contentDetailsPageAlsoFoundInSubPageView";
import ContentDetailsPageCommentsSubPageView from "scripts/views/contentDetailsPageCommentsSubPageView";
import ContentDetailsPageNotesSubPageView from "scripts/views/contentDetailsPageNotesSubPageView";
import ContentDetailsVideoPageDetailsSubPageView from "scripts/views/contentDetailsVideoPageDetailsSubPageView";
import ContentDetailsVideoPageView from "scripts/views/contentDetailsVideoPageView";
import ContentDetailsChaptersSubPageView from "scripts/views/contentDetailsChaptersSubPageView";
import ContentModel from "scripts/models/contentModel";
import CitationsView from "./citationsView";

const chan = Backbone.Radio.channel;

class ContentDetailsControllerView extends BaseView {
  constructor(options) {
    super(options);
    this.queryParams = options.queryParams;
    this.subPageType = options.subPageType;

    this.contentModel = new ContentModel({
      id: options.mediaId,
    });

    chan("controllerView").reply(
      "contentDetailsControllerView",
      mediaId => {
        if (this.contentModel.id === mediaId) {
          return this;
        }
      },
      this,
    );
  }

  sync() {
    return this.contentModel
      .fetch()
      .then(() => {
        if (this.contentDetailsPageView) {
          this.contentDetailsPageView.close();
        }

        this.contentDetailsPageView = this.addSubView(
          this.createContentDetailsPageView(),
        );
      })
      .then(() => this.contentDetailsPageView.fetch());
  }

  render() {
    this.contentDetailsPageView.appendTo(this.$el).render();

    return this;
  }

  getBreadcrumbInfo() {
    return this.contentDetailsPageView.getBreadcrumbInfo();
  }

  showContentDetailsSubPageType(subPageType) {
    this.subPageType = subPageType;

    this.contentDetailsPageView.model.set("subPageType", subPageType);

    return this.contentDetailsPageView.showSubPageView(
      this.createContentDetailsSubPageView(),
    );
  }

  createContentDetailsPageView() {
    const subPageView = this.createContentDetailsSubPageView();

    const pageModel = new Backbone.Model({
      mediaId: this.contentModel.get("id"),
      subPageType: this.subPageType,
      queryParams: this.queryParams,
    });

    const contentType = this.contentModel.get("type");

    if (contentType === "BOOK") {
      return new ContentDetailsBookPageView({
        model: pageModel,
        mediaModel: this.contentModel,
        subPageView: subPageView,
      });
    } else if (contentType === "CHAPTER") {
      return new ContentDetailsChapterPageView({
        model: pageModel,
        mediaModel: this.contentModel,
        subPageView: subPageView,
      });
    } else if (contentType === "ARTICLE") {
      return new ContentDetailsArticlePageView({
        model: pageModel,
        mediaModel: this.contentModel,
        subPageView: subPageView,
      });
    } else if (contentType === "OTHER_DOCUMENT") {
      return new ContentDetailsDocumentPageView({
        model: pageModel,
        mediaModel: this.contentModel,
        subPageView: subPageView,
      });
    } else if (contentType === "IMAGE") {
      return new ContentDetailsImagePageView({
        model: pageModel,
        mediaModel: this.contentModel,
        subPageView: subPageView,
      });
    } else if (contentType === "VIDEO") {
      return new ContentDetailsVideoPageView({
        model: pageModel,
        mediaModel: this.contentModel,
        subPageView: subPageView,
      });
    } else if (contentType === "AUDIO") {
      return new ContentDetailsAudioPageView({
        model: pageModel,
        mediaModel: this.contentModel,
        subPageView: subPageView,
      });
    } else {
      return new ContentDetailsBookPageView({
        model: pageModel,
        mediaModel: this.contentModel,
        subPageView: subPageView,
      });
    }
  }

  createContentDetailsSubPageView() {
    const contentType = this.contentModel.get("type");
    const mediaId = this.contentModel.get("id");

    if (this.subPageType === "details") {
      if (contentType === "BOOK") {
        return new ContentDetailsBookPageDetailsSubPageView({
          model: this.contentModel,
        });
      } else if (contentType === "CHAPTER") {
        return new ContentDetailsChapterPageDetailsSubPageView({
          model: this.contentModel,
        });
      } else if (contentType === "ARTICLE") {
        return new ContentDetailsArticlePageDetailsSubPageView({
          model: this.contentModel,
        });
      } else if (contentType === "OTHER_DOCUMENT") {
        return new ContentDetailsDocumentPageDetailsSubPageView({
          model: this.contentModel,
        });
      } else if (contentType === "IMAGE") {
        return new ContentDetailsImagePageDetailsSubPageView({
          model: this.contentModel,
        });
      } else if (contentType === "VIDEO") {
        return new ContentDetailsVideoPageDetailsSubPageView({
          model: this.contentModel,
        });
      } else if (contentType === "AUDIO") {
        return new ContentDetailsAudioPageDetailsSubPageView({
          model: this.contentModel,
        });
      } else {
        return new ContentDetailsBookPageDetailsSubPageView({
          model: this.contentModel,
        });
      }
    } else if (this.subPageType === "notes") {
      return new ContentDetailsPageNotesSubPageView({
        // Share the model????
        model: new ContentModel({
          id: mediaId,
        }),
      });
    } else if (this.subPageType === "comments") {
      return new ContentDetailsPageCommentsSubPageView({
        model: new Backbone.Model({
          mediaId: mediaId,
        }),
      });
    } else if (this.subPageType === "also-found-in") {
      return new ContentDetailsPageAlsoFoundInSubPageView({
        model: new Backbone.Model({
          mediaId: mediaId,
        }),
      });
    } else if (this.subPageType === "chapters") {
      return new ContentDetailsChaptersSubPageView({
        model: new Backbone.Model({
          mediaId: mediaId,
        }),
      });
    } else if (this.subPageType === "citations") {
      return new CitationsView({
        model: new Backbone.Model({
          mediaId: mediaId,
        }),
      });
    }
  }

  getDocumentTitle() {
    return this.contentDetailsPageView.getDocumentTitle();
  }
}

export default ContentDetailsControllerView;
